const bitResolver = require('./bit-resolver');

module.exports = bitResolver;
